"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _swiftInputTabsStyle = require("./swift-input-tabs-style");
var _swiftLabel = _interopRequireDefault(require("./swift-label"));
var _jsxRuntime = require("react/jsx-runtime");
var SwiftInputTabs = function SwiftInputTabs(props) {
  //console.log("SwiftInputTabs - props", props)
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_swiftInputTabsStyle.SwiftInputTabsStyled, {
      children: [props.label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
        children: props.label
      }), props.sublabel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
        type: "sublabel",
        children: props.sublabel
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        children: props.values.map(function (elem, i) {
          //console.log("radio - value", elem)
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            className: props.value == elem.value ? 'active' : '',
            onClick: function onClick() {
              return props.onChange(elem.value);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: elem.name && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  children: elem.name
                })
              })
            })
          }, i);
        })
      }), props.error && props.helperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
        error: true,
        children: props.helperText
      }) : null]
    })
  });
};
var _default = SwiftInputTabs;
/*

<div className="swift_input_tab" key={props.name + '-' + elem.value}>
						<label htmlFor={props.name + '-' + elem.value}>
							<input
								type="radio"
								name={props.name}
								key={props.name}
								disabled={elem.disabled ?? false}
								id={props.name + '-' + elem.value}
								checked={props.value === elem.value ? true : false}
								onChange={(e) => props.onChange(elem.value, e)}
							/>
							{elem.name && <span>{elem.name}</span>}

							{elem.link && (
								<div className="swift_input_radio_label_link">
									{elem.link.onClick ? (
										<a onClick={elem.link.onClick}>
											<span>{elem.link.label || 'View'}</span>
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
												<path d="M0 3.795l2.995-2.98 11.132 11.185-11.132 11.186-2.995-2.981 8.167-8.205-8.167-8.205zm18.04 8.205l-8.167 8.205 2.995 2.98 11.132-11.185-11.132-11.186-2.995 2.98 8.167 8.206z" />
											</svg>
										</a>
									) : (
										<a target="_blank" href={elem.link.url ? elem.link.url : elem.link}>
											<span>{elem.link.label || 'View'}</span>
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
												<path d="M0 3.795l2.995-2.98 11.132 11.185-11.132 11.186-2.995-2.981 8.167-8.205-8.167-8.205zm18.04 8.205l-8.167 8.205 2.995 2.98 11.132-11.185-11.132-11.186-2.995 2.98 8.167 8.206z" />
											</svg>
										</a>
									)}
								</div>
							)}
						</label>
					</div>
					*/
exports.default = _default;